import { ValueOf } from "../utils/utils";

export interface Application {
    labelKey: string;
    id: ApplicationId;
}

export const APPLICATION_IDS = {
    WELDING: 1,
    PLASTIC: 2,
    CUTTING: 3,
    HARDENING: 4,
    MARKING: 5,
    OTHER: 6,
    FIXED_OPTICS_BEO: 7,
    PFO20_33: 8,
    PFO3D: 9,
    I_PFO: 10,
    OTHER_OPTICS: 11,
    WELD_DEPTH: 12,
    HARDNESS: 13,
    CRACKING: 14,
    BUBBLE_SPLATTER: 15,
    PROCESS_DATA: 16,
    OTHER_WELDING: 17
};

export const TECHNOLOGIES_WITH_APPLICATION = [
    "PULSEDLASER",
    "SHORTPULSEDLASER",
    "DISKLASER",
    "FIBERLASER",
    "DIODELASER",
    "MARKINGLASER"
];

export type ApplicationId = ValueOf<typeof APPLICATION_IDS>;

export const applicationsLaser: Application[] = [
    {
        labelKey: "welding",
        id: APPLICATION_IDS.WELDING
    },
    {
        labelKey: "plastic",
        id: APPLICATION_IDS.PLASTIC
    },
    {
        labelKey: "cutting",
        id: APPLICATION_IDS.CUTTING
    },
    {
        labelKey: "hardening",
        id: APPLICATION_IDS.HARDENING
    },
    {
        labelKey: "marking",
        id: APPLICATION_IDS.MARKING
    },
    {
        labelKey: "other",
        id: APPLICATION_IDS.OTHER
    }
];

export const applicationsOptics: Application[] = [
    {
        labelKey: "fixedOpticsBEO",
        id: APPLICATION_IDS.FIXED_OPTICS_BEO
    },
    {
        labelKey: "PFO20/33",
        id: APPLICATION_IDS.PFO20_33
    },
    {
        labelKey: "PFO3D",
        id: APPLICATION_IDS.PFO3D
    },
    {
        labelKey: "I-PFO",
        id: APPLICATION_IDS.I_PFO
    },
    {
        labelKey: "other",
        id: APPLICATION_IDS.OTHER_OPTICS
    }
];

export const applicationsWelding: Application[] = [
    {
        labelKey: "weldDepth",
        id: APPLICATION_IDS.WELD_DEPTH
    },
    {
        labelKey: "hardness",
        id: APPLICATION_IDS.HARDNESS
    },
    {
        labelKey: "cracking",
        id: APPLICATION_IDS.CRACKING
    },
    {
        labelKey: "bubbleSplatter",
        id: APPLICATION_IDS.BUBBLE_SPLATTER
    },
    {
        labelKey: "processData",
        id: APPLICATION_IDS.PROCESS_DATA
    },
    {
        labelKey: "other",
        id: APPLICATION_IDS.OTHER_WELDING
    }
];
